import { handleUrl, myHeadersWithTokenContentType } from '../global';
import { requestJson } from '../http';
import {
  GetNotificationsProps,
  MarkNotificationsProps,
  NotificationKind,
} from './types';

/**
 * Unread notifications of the user in the active company, restricted to
 * `kinds`. Paginated: `detail.total_records` is the unread count.
 */
export const getUnreadNotifications = (
  kinds: NotificationKind[],
  page: number,
  size: number,
  signal?: AbortSignal
): Promise<GetNotificationsProps> => {
  const params = new URLSearchParams({
    page: String(page),
    size: String(size),
  });
  kinds.forEach((kind) => params.append('kinds', kind));
  return requestJson(
    `${handleUrl()}/api/V1/notifications?${params.toString()}`,
    { method: 'GET', headers: myHeadersWithTokenContentType() },
    signal
  );
};

export const markNotificationsAsRead = (
  ids: number[]
): Promise<MarkNotificationsProps> =>
  requestJson(`${handleUrl()}/api/V1/notifications`, {
    method: 'PATCH',
    headers: myHeadersWithTokenContentType(),
    body: JSON.stringify({ notification_ids: ids }),
  });
